import { TFunction } from 'i18next';
import { WorkerProfile } from 'src/DTO/WorkerProfile.type';
import { POOL_STATUS } from 'src/DTO/PoolStatus.enum';
import { getNewestByCreatedDate } from 'src/utils/getNewestByCreatedDate';
import { WorkerScope } from 'src/api/hooks/useWorker.types';
import { ActionType } from 'src/pages/Workers/components/types';

export const getJobTitles = (worker: WorkerProfile, t: TFunction) => {
  if (!worker?.jobs?.length) return '';

  if (worker.jobs.length > 1) {
    return `${getNewestByCreatedDate(worker.jobs).role.name} +${worker.jobs.length - 1} ${t(
      'workersScreen.more',
    )}`;
  }
  return worker.jobs[0].role.name;
};

export const getOfferTitles = (worker: WorkerProfile, t: TFunction) => {
  if (!worker?.offers?.length) return '';
  if (worker.offers.length > 1 || (worker.jobs && worker.jobs.length > 1)) {
    return `${getNewestByCreatedDate(worker.offers).job.role.name} +${
      worker.offers.concat((worker.jobs as any) || []).length - 1
    } ${t('workersScreen.more')}`;
  }
  return getNewestByCreatedDate(worker.offers).job.role.name;
};

export const getApplicationTitles = (worker: WorkerProfile, t: TFunction) => {
  if (!worker?.applications?.length) return '';

  if (worker.applications.length > 1) {
    return `${getNewestByCreatedDate(worker.applications).job.role.name} +${
      worker.applications.length - 1
    } ${t('workersScreen.more')}`;
  }
  return getNewestByCreatedDate(worker.applications).job.role.name;
};

export const getJobsTitle = (worker: WorkerProfile, t: TFunction) => {
  const { poolStatus } = worker;

  if (poolStatus === POOL_STATUS.ACTIVE) {
    return getJobTitles(worker, t);
  }
  if (poolStatus === POOL_STATUS.PENDING_OFFER || poolStatus === POOL_STATUS.WORKER_UNDER_REVIW) {
    return getOfferTitles(worker, t);
  }
  if (poolStatus === POOL_STATUS.NEW_APPLICATION) {
    return getApplicationTitles(worker, t);
  }
  return '';
};

export const handleOpenWorkerProfile = (worker: WorkerProfile) => {
  const workerUrl = `/worker/${worker.id}`;
  window.open(workerUrl, '_blank');
};

export const workersTableTranslations = {
  title: {
    [WorkerScope.AVAILABLE]: 'workersScreen.availableWorkerList.availableWorkerList',
    [WorkerScope.INVITED]: 'workersScreen.invitedWorkerList.invitedWorkerList',
  },
  emptyMessage: {
    [WorkerScope.AVAILABLE]: 'workersScreen.availableWorkerList.emptyMessage',
    [WorkerScope.INVITED]: 'workersScreen.invitedWorkerList.emptyMessage',
  },
};

export const getJobOptions = (options: any) => {
  return options.map((option: any) => ({
    label: option?.job?.role?.name || option?.role?.name || '',
    id: option.id,
  }));
};

export const getActionSubText = (action: ActionType, name: string, t: TFunction) => {
  if (!name || !action) return '';

  switch (action) {
    case 'acceptApp':
      return t('workersPage.actions.handleApplication.subtitle.accept', { name });
    case 'declineApp':
      return t('workersPage.actions.handleApplication.subtitle.decline', { name });
    case 'terminate':
      return t('workersPage.actions.terminateWorker.subtitle', { name });
    default:
      return '';
  }
};
